module.exports = __webpack_public_path__ + "static/img/btn_task_yes2.1dd063f1.svg";